var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"play"},[_c('div',{staticClass:"play",attrs:{"id":"mse"}})])
}]

export { render, staticRenderFns }